import path from "path";

export const ROOT_DIR = path.resolve(__dirname, "../..");
